import { listeners } from '@/plugins/event-bus';
import { WS } from './ws';
import WSRoutes from './wsroutes';


// same ws instance is used inside wsFactory
let ws: any;

const wsFactory = {
  open: async (app: any, eventBus: any, endpoint: string) => {
    try {
      ws = new WS(endpoint);
      await ws.init();

      const wsEvents = listeners.onWebsocketOpen.events;
      listeners.onWebsocketOpen.register(app);

      ws.onCloseHandler = () => {
        ws.reopen();
        eventBus.$emit(wsEvents.IS_CLOSED);
      };
      ws.onAliveHandler = () => {
        eventBus.$emit(wsEvents.IS_ALIVE);
      };
      ws.addHandler(new WSRoutes(wsEvents, eventBus));

      // window.ws = ws; // prod: remove
    } catch (e) {
      console.error(e);
    }
  },

  destroy: () => {
    ws.destroy();
    console.log('websocket destroyed'); // prod: remove
  },
};

export default wsFactory;
